import { useState } from "react"
import { Box, Button, ButtonProps, DialogActions, DialogTitle } from "@mui/material";
import { Dialog, DialogContent, useMountEffect } from "@sis/react-library"
import { DropzoneInput } from "./DropzoneInput"
import { ImageCropper } from "./ImageCropper";

interface ModalImageCropperProps {
    onCroppedImage: (file: File, fileName: string) => void;
    aspectRatio?: number,
    disabled: boolean;
}

export const ModalImageCropper = ({
    onCroppedImage, aspectRatio, disabled
}: ModalImageCropperProps) => {

    useMountEffect(() => {
        setShowDialogContent(false);
    })

    const [files, setFiles] = useState<File[]>([])
    const [openModal, setOpenModal] = useState(false)
    const [image, setImage] = useState<File | undefined>(undefined);
    const [showDialogContent, setShowDialogContent] = useState(false);

    const handleFilesChange = (values: File[]) => {
        setFiles(values);
        setOpenModal(values.length === 1);
        globalThis.setTimeout(() => {
            setShowDialogContent(true);
        }, 500);
    }

    const handleOK = () => {
        if (image) {
            onCroppedImage(image, files[0].name);
            setOpenModal(false);
        }
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const buttonProps: ButtonProps = { sx: { width: '100px' } }

    return (
        <>
            <DropzoneInput
                onFilesChange={handleFilesChange}
                disabled={disabled}
            />
            <Dialog
                open={openModal && files?.length === 1}
                onClose={handleCloseModal}
                closeOnClickOff
            >
                <DialogTitle>Crop image</DialogTitle>
                <DialogContent>
                    <Box sx={{ width: '450px', height: '500px', position: 'relative' }}>
                        <Box sx={{ width: '450px', height: '500px', left: 0, position: 'absolute' }}>
                            {files?.length === 1 && showDialogContent &&
                                <ImageCropper
                                    setImage={setImage}
                                    // Allow any below
                                    // eslint-disable-next-line
                                    imagePreview={(files[0] as any)}
                                    aspectRatio={aspectRatio}
                                />
                            }
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="outlined"
                        onClick={handleCloseModal}
                        {...buttonProps}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleOK}
                        {...buttonProps}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
